import { CollapseDate } from 'shared/layouts/details-layout/DetailsLayout.model'
import { MainView } from './Tenant.types'
import { IActivePackage } from './package-features/PackageFeatures.types'

export const hasRetailPackage = (appCode: string, activePackages?: IActivePackage[]): boolean =>
  !!activePackages?.some((pkg) => pkg.application_code === appCode && pkg.is_retail === true)

export const getCollapseData = (): CollapseDate[] => [
  {
    id: MainView.organizations,
    title: 'organizations.organizations',
    listItems: [
      'organizations.accountOrganizations',
      'organizations.manageOrganizations'
    ]
  }
]
